import { gql } from '@apollo/client'

export const GET_POWER_BI_TOKEN = gql`
  query GetPowerBiToken {
    getPowerBiToken {
      token
    }
  }
`
